/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RenderTableOrderInput = {
    id?: (string | null);
    /**
     * LX expression to sort by. It may be a hidden column.
     */
    expression: string;
    /**
     * Namespace id/name. Defaults to request namespace.
     */
    namespace?: (string | null);
    direction?: RenderTableOrderInput.direction;
    /**
     * Deprecated compatibility flag. Cashflow routing is detected from property metadata.
     */
    is_cashflow?: boolean;
};

export namespace RenderTableOrderInput {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

